import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/tam/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import AccountDetail from "@/pages/AccountDetail";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Tasks from "@/pages/Tasks";
import Submissions from "@/pages/Submissions";
import Uploads from "@/pages/Uploads";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route element={<Guard><Layout /></Guard>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/:id" element={<AccountDetail />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:code" element={<ProductDetail />} />
        <Route path="/submissions" element={<Guard roles={["manager", "user"]}><Submissions /></Guard>} />
        <Route path="/tasks" element={<Guard roles={["manager", "purfleet_manager"]}><Tasks /></Guard>} />
        <Route path="/uploads" element={<Guard roles={["manager"]}><Uploads /></Guard>} />
        <Route path="/audit" element={<Guard roles={["manager"]}><AuditLog /></Guard>} />
        <Route path="/users" element={<Guard roles={["manager"]}><Users /></Guard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
